import React from 'react'

import { TbList } from 'react-icons/tb'

import { useIntl } from '@app/intl/Intl'
import { BlockButton } from '@app/lib/inputs/RichEditor/blocks/BlockButton'
import { ListElementType } from '@app/lib/inputs/RichEditor/types'

export const BulletedListButton = () => {
  const { formatMessage } = useIntl()

  return (
    <BlockButton
      format={ListElementType.BulletedList}
      icon={<TbList />}
      aria-label={formatMessage({ id: 'RichEditor.Element.BulletedList' })}
    />
  )
}
